/**
 * Created by matheusmorett on 24/08/17.
 */
import Login from './Login';
export default Login;
